import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";

import "../excalidraw-app/sentry";

import ExcalidrawApp from "./App";
import { RyfeApp } from "./ryfe/RyfeApp";

window.__EXCALIDRAW_SHA__ = import.meta.env.VITE_APP_GIT_SHA;
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
registerSW();

// RYFE — Whiteboard is the product; render the RYFE shell by default. Set
// VITE_APP_RYFE=false to boot the upstream Excalidraw reference app instead.
const useRyfe = import.meta.env.VITE_APP_RYFE !== "false";

root.render(
  <StrictMode>{useRyfe ? <RyfeApp /> : <ExcalidrawApp />}</StrictMode>,
);
